import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {useParams} from 'react-router'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {DropdownDefault, InputDefault, TableDefault} from '../../../../components/ui'
import {getListMemberCycle} from '../../../../modules/services/member.service'
import {getSelfCareById} from '../../../../modules/services/self-care.service'
import ModalProgressState from '../../../../components/sections/ModalProgressState'
import {getBreadCrumbs} from '../../breadcrumbs'
import {customerStateMock} from '../../../../mocks/'
import {useStateContext} from '../../../../contexts/State'

const CustomerStateDetailPage = () => {
  const {progressId, setProgressId} = useStateContext()
  const {id} = useParams<{id: string}>()
  const headFields = ['Member Name', 'Active Status', 'Member Terms (Days)']
  const bodyFields = [
    'attributes.member.data.attributes.fullname',
    'attributes.member.data.attributes.activeStatus',
    'attributes.memberTerms',
  ]
  const {data: member} = useQuery(['getListMemberByCycleId', id], async () =>
    getListMemberCycle(id as string)
  )
  const {data: cycle} = useQuery(['getSelfCareById', id], async () => getSelfCareById(id as string))
  const members = member?.data

  const [filter, setFilter] = useState('')

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])
  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>
              Member List <span> - {cycle?.attributes.name}</span>
            </p>
          </div>
          <div className='me-6 d-flex flex-column align-items-end gap-4'>
            <div className='d-flex flex-row gap-4'>
              <button
                className='btn btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#import-member'
              >
                Import
              </button>
              <button
                className='btn btn-primary'
                data-bs-toggle='modal'
                data-bs-target='#add-edit-member'
              >
                Add
              </button>
            </div>
            <div className='d-flex flex-row gap-4'>
              <InputDefault placeholder='Search' left={<i className='bi bi-search' />} />
              <DropdownDefault
                type='Filter'
                list={customerStateMock.filters}
                dataState={[filter, setFilter]}
              />
            </div>
          </div>
        </div>
        <TableDefault
          head={headFields}
          body={bodyFields}
          data={members as Array<any>}
          href='member-management/customer-state'
          customBtnAction='Detail Progress'
          customBtnActionProps={{
            'data-bs-toggle': 'modal',
            'data-bs-target': '#progress-state',
          }}
          customBtnOnClickWithId={setProgressId}
        />
        <ModalProgressState id={progressId} />
      </div>
    </>
  )
}

const CustomerStateDetailWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('/member-management/member')}>
        {intl.formatMessage({id: 'MENU.MEMBER'})}
      </PageTitle>
      <CustomerStateDetailPage />
    </>
  )
}

export default CustomerStateDetailWrapper
